import { ACTIONS, USERTYPES } from "../../../constants/Constants"

export const data = (state, checkFirm, userData, userType, whatsappParentEnabled, emailParentEnabled) => {
  console.log("In data --->",userData , userType)
    return (
        (state.action === ACTIONS.EDIT || state.action === ACTIONS.VIEW)
      ? {
          id:userData?.user?.id,
          role: userType,
          firstName: userData?.user?.firstName,
          lastName: userData?.user?.lastName,
          //email: userData?.user?.email,
          mobile: userData?.user?.mobile,
          username: userData?.user?.username,
          password: "password",
          confirmPassword: "password",
          active: userData?.user?.active,
          action: state.action,
          accountNonLocked: userData?.user?.accountNonLocked, 
          firmIdList: checkFirm,
          twoFactorEnabled: userData?.user?.twoFactorEnabled,
          countOfconnections: userData?.user?.countOfconnections,
          showRadiologistTime: userData?.user?.showRadiologistTime,
          showConfirmation: userData?.user?.showConfirmation,
          radiologistType: userData?.user?.radiologistType,
          showAllStudies: userData?.user?.showAllStudies,
          disableSubmit: userData?.user?.disableSubmit,
          showAllStudy: userData?.user?.showAllStudy ?? false,
          allowSubmit: userData?.user?.allowSubmit ?? true,
          showAddStudy: userData?.user?.showAddStudy,
          showChats: userData?.user?.showChats,
          showHistory: userData?.user?.showHistory,
          showViewer: userData?.user?.showViewer,
          connectedRadiologistIds: userData?.user?.connectedRadiologistIds || [],
          sendAssignMail: userData?.user?.sendAssignMail,
          checkCapacityOnManualAssign: userData?.user?.checkCapacityOnManualAssign,
          onPayroll: userData?.user?.onPayroll,
          uploadStudy: userData?.user?.uploadStudy,
          qcRadiologist: userData?.user?.qcRadiologist,
          qcSupervisor: userData?.user?.qcSupervisor,
          keyImage:userData?.user?.keyImage,
          qcSaveReport:userData?.user?.qcSaveReport,
          qcOutsourceLogin:userData?.user?.qcOutsourceLogin,
          capacity: userData?.user?.capacity,
          modalityWithSubModalityPreferences: (userType===USERTYPES.RADIOLOGIST || userType===USERTYPES.SUPERVISOR) ? ((userData!==undefined && userData?.modalityWithSubModalityPreference!==undefined)? userData?.modalityWithSubModalityPreferences: [] ) : [],
          // modalityWithSubModalityPreferences:[{modalityId:1, modalityName:"DX",subModalities:[{id:2, serviceName:"sub mod 2",listNumber:1,modalityId:1, serviceCode:"BVCR"},{id:3, serviceName:"sub mod 3",listNumber:1,modalityId:1, serviceCode:"BVCR"}]},
          // {modalityId:2, modalityName:"CT",subModalities:[{id:1, serviceName:"sub mod 1",listNumber:2,modalityId:2, serviceCode:"BVCR"},{id:2, serviceName:"sub mod 2",listNumber:2,modalityId:2, serviceCode:"BVCR"}]}],
          signatureText: userData?.user?.signatureDto?.signatureText,
          isSignatureImageDeleted: null,
          signatureDto: {
            isSignatureImageDeleted: userData?.user?.signatureDto?.isSignatureImageDeleted ? 1 : 0,
            signatureImageUrl: userData?.user?.signatureDto?.signatureImageUrl,
            signatureImage: null,
          },
          signatureImage: null,
          code: userData?.user?.code,
          firmCode: userData?.firmCode,
          firmName: userData?.user?.userFirmDto?.name,
          pediatricSpecialist: userData?.user?.pediatricSpecialist,
          specialist: userData?.user?.specialist ?? "",
          selectedPediatricModalityId: userData?.user?.selectedPediatricModalityId,
          technicianContactList : (userType===USERTYPES.FIRMTECHNICIAN || userType===USERTYPES.FIRMDOCTOR || userType===USERTYPES.FIRMADMIN) ? ((userData!==undefined && userData?.user?.technicianContactList!==undefined)? userData?.user?.technicianContactList: [] ) : [],
          // technicianContactList: userData?.technicianContactList
          enableTypistWorkflow: userData?.user?.enableTypistWorkflow,
          enableHistoryUpload: userData?.user?.enableHistoryUpload,
          allowDeleteStudy: userData?.user?.allowDeleteStudy,
          showClientName: userData?.user?.showClientName,
          showWord: userData?.user?.showWord,
          enableLlmReport: userData?.user?.enableLlmReport,
          isPeerReviewAdmin:userData?.user?.peerReviewAdmin,
          isPeerReviewEvaluator:userData?.user?.peerReviewEvaluator,
          isPasswordResetAllowed:userData?.user?.passwordResetAllowed,
          isForcedLogoutAllowed:userData?.user?.forcedLogoutAllowed,
          isExportCsvAllowed:userData?.user?.exportCsvAllowed,
          enableStudyUpload: userData?.user?.enableStudyUpload,
          allowStudyEdit: userData?.user?.allowStudyEdit,
          showAiResults: userData?.user?.showAiResults,
          showSavedReport: userData?.user?.showSavedReport,
          showViewerTechnician: userData?.user?.showViewerTechnician,
          enableWhatsApp: !whatsappParentEnabled ? false : ((!emailParentEnabled && whatsappParentEnabled) ? true : !!userData?.user?.enableWhatsApp) ,
          whatsappNumber: userData?.user?.whatsappNumber ?? "" ,
          enableEmail: !emailParentEnabled ? false : ((!whatsappParentEnabled && emailParentEnabled) ? true : !!userData?.user?.enableEmail) ,
          email: userData?.user?.email ?? "",
          emailParentEnabled: !!emailParentEnabled,
          whatsappParentEnabled: !!whatsappParentEnabled,
          enableReportAndHeaderTemplateConfigurations:userData?.user?.enableReportAndHeaderTemplateConfigurations,
          unassignmentModalityIds: userData?.user?.unassignmentModalityIds || [],
        }
      : {
          firstName: "",
          role: userType,
          lastName: "",
          //email: "",
          mobile: "",
          username: "",
          password: "",
          confirmPassword: "",
          active: true,
          action: state.action,
          firmIdList: checkFirm,
          showRadiologistTime: false,
          showConfirmation: true,
          radiologistType: 1,
          showAllStudies: true,
          disableSubmit: false,
          showAllStudy: false,
          allowSubmit: true,
          showAddStudy: false,
          showChats: false,
          showHistory: false,
          showViewer: false,
          connectedRadiologistIds: [],
          sendAssignMail: false,
          sendWelcomNotification: true,
          checkCapacityOnManualAssign: false,
          onPayroll: false,
          uploadStudy: false,
          qcRadiologist: false,
          qcSupervisor:false,
          keyImage:false,
          qcSaveReport:false,
          qcOutsourceLogin:false,
          capacity: 10,
          isSignatureImageDeleted: null,
          signatureDto: {
            isSignatureImageDeleted: 0,
            signatureImageUrl: null,
            signatureImage: null,
          },
          modalityWithSubModalityPreference:[],
          signatureText: "",
          signatureImage: null,
          pediatricSpecialist: false,
          specialist: "",
          selectedPediatricModalityId: [],
          technicianContactList: [],
          enableTypistWorkflow: 0,
          enableHistoryUpload: false,
          showClientName: false,
          allowDeleteStudy: false,
          showWord: false,
          accountNonLocked: true,
          twoFactorEnabled: false,
          enableLlmReport: false,
          isPeerReviewAdmin:userData?.user?.isPeerReviewAdmin,
          isPeerReviewEvaluator:userData?.user?.isPeerReviewEvaluator,
          isPasswordResetAllowed:userData?.user?.passwordResetAllowed,
          isForcedLogoutAllowed:userData?.user?.forcedLogoutAllowed,
          isExportCsvAllowed:userData?.user?.exportCsvAllowed,
          enableStudyUpload: false,
          allowStudyEdit: false,
          showAiResults: false,
          showSavedReport: false,
          showViewerTechnician: false,
          //enableWhatsApp: !!userData?.user?.enableWhatsApp ,
          enableWhatsApp: (!(emailParentEnabled && whatsappParentEnabled) && whatsappParentEnabled) ,

          whatsappNumber: userData?.user?.whatsappNumber ?? "",
          //enableEmail: !!userData?.user?.enableEmail,
          enableEmail: emailParentEnabled ,
          email: userData?.user?.email ?? "",
          emailParentEnabled: !!emailParentEnabled,
          whatsappParentEnabled: !!whatsappParentEnabled,
          enableReportAndHeaderTemplateConfigurations:false,
          unassignmentModalityIds: [],
        }
    )
}

export const addTabStatusInitialValue = {
  tab1Status: { value: "Info", color: "#FF9900" },
  tab2Status: { value: "Info", color: "#FF9900" },
  tab3Status: { value: "Info", color: "#FF9900" },
  tab4Status: { value: "Info", color: "#FF9900" },
  tab5Status: { value: "Info", color: "#FF9900" },
  tab6Status: { value: "Info", color: "#FF9900" },
};

export const editTabStatusInitialValue = {
  tab1Status: { value: "Completed", color: "green" },
  tab2Status: { value: "Completed", color: "green" },
  tab3Status: { value: "Completed", color: "green" },
  tab4Status: { value: "Completed", color: "green" },
};

export const setInitialProfileData = (profileData) => {
   console.log(profileData)
     const gateWA = !!profileData.enableWhatsApp;
  const gateEmail = !!profileData.enableEmail;
  const bothEnabled = gateWA && gateEmail;

  // Default per-user selection:
  // - If only one gate is enabled -> user must have it on (true)
  // - If both gates are enabled -> use the stored contact presence to decide
  const initialUseWhatsApp = gateWA ? (bothEnabled ? !!(profileData.whatsappNumber) : true) : false;
  const initialUseEmail = gateEmail ? (bothEnabled ? !!(profileData.email) : true) : false;

  return ( {
        firstName: profileData?.firstName,
        lastName: profileData?.lastName,
        specialist: profileData?.specialist ?? "",
        mobile: profileData?.mobile,
        username: profileData?.username,
        password:"Admin@123",
        confirmPassword:"Admin@123",
        active: profileData?.active,
        showRadiologistTime: profileData?.showRadiologistTime,
        showConfirmation: profileData?.showConfirmation,
        sendAssignMail: profileData?.sendAssignMail,
        checkCapacityOnManualAssign: profileData?.checkCapacityOnManualAssign,
        signatureText: profileData?.signatureDto?.signatureText,
    signatureImage: null,
    signatureDto: {
      isSignatureImageDeleted: 0,
      signatureImage: null,
      enableWhatsApp: profileData?.enableWhatsApp,
      enableEmail: profileData?.enableEmail,
    },
    technicianContactList: profileData?.technicianContactList != null ? profileData?.technicianContactList: [],

    // --- master gates from server (read-only in many UIs) ---
    enableEmail: gateEmail,
    enableWhatsApp: gateWA,

    // --- per-user toggles (what the user can check/uncheck) ---
    useEmail: initialUseEmail,
    useWhatsApp: initialUseWhatsApp,

    // --- contact values (populate only if gate exists) ---
    email: gateEmail && profileData.email ? profileData.email : "",
    whatsappNumber: gateWA && profileData.whatsappNumber ? profileData.whatsappNumber : "",
    checkSecurityFlag: !!profileData?.strictCyberSecurity,

})
}